import { combineReducers } from 'redux'
import users, { STATE_KEY as USERS_STATE_KEY } from './users'

export const STATE_KEY = 'users'

const reducer = combineReducers({
	[USERS_STATE_KEY]: users
})

export default reducer